// extracted by mini-css-extract-plugin
export var Container = "looper-module--Container--3ZypD";
export var Slide = "looper-module--Slide--4rJJv";
export var slideRightToLeft = "looper-module--slideRightToLeft--XRfXp";